const S = { "aria-hidden": "true", focusable: "false" };

function Tray() {
  return (
    <svg viewBox="0 0 160 120" {...S}>
      <ellipse cx="80" cy="92" rx="66" ry="18" fill="#E8A91C" />
      <ellipse cx="80" cy="88" rx="66" ry="18" fill="#FFC83D" />
      <ellipse cx="80" cy="88" rx="54" ry="13" fill="none" stroke="#E8A91C" strokeWidth="1.5" strokeDasharray="3 4" />
      <rect x="40" y="52" width="16" height="32" rx="3" fill="#FFF7E8" stroke="#142344" />
      <rect x="40" y="64" width="16" height="20" rx="2" fill="#F3A126" />
      <rect x="104" y="52" width="16" height="32" rx="3" fill="#FFF7E8" stroke="#142344" />
      <rect x="104" y="62" width="16" height="22" rx="2" fill="#D81B60" />
      <path d="M66 84 Q80 78 94 84 Q90 94 80 94 Q70 94 66 84 Z" fill="#142344" />
      <path d="M80 60 C85 68 86 74 82 78 C80 80 78 78 78 78 C74 74 75 68 80 60 Z" fill="#F3A126" className="flame" />
      <circle cx="64" cy="98" r="4" fill="#F3A126" /><circle cx="96" cy="98" r="4" fill="#E8891A" />
    </svg>
  );
}

function Mithai() {
  const l = [[56, 78], [80, 78], [104, 78], [68, 60], [92, 60], [80, 43]];
  return (
    <svg viewBox="0 0 160 120" {...S}>
      <ellipse cx="80" cy="96" rx="62" ry="14" fill="#FFC83D" />
      <ellipse cx="80" cy="93" rx="50" ry="9" fill="#FFF7E8" />
      {l.map(([x, y], i) => (
        <g key={i}><circle cx={x} cy={y} r="12" fill="#F3A126" /><circle cx={x - 3} cy={y - 4} r="2" fill="#FFE3A3" /><circle cx={x + 4} cy={y + 2} r="1.5" fill="#C96F12" /></g>
      ))}
      <path d="M20 92 l10 -8 l10 8 l-10 8 z" fill="#E9E4D6" stroke="#142344" />
      <path d="M120 92 l10 -8 l10 8 l-10 8 z" fill="#E9E4D6" stroke="#142344" />
    </svg>
  );
}

function Cards() {
  const card = (rot, pip, color) => (
    <g transform={`rotate(${rot} 80 110)`}>
      <rect x="58" y="26" width="44" height="64" rx="6" fill="#FFF7E8" stroke="#142344" strokeWidth="2" />
      <text x="66" y="42" fontSize="12" fontFamily="serif" fill={color}>A</text>
      <path d={pip} fill={color} />
    </g>
  );
  return (
    <svg viewBox="0 0 160 120" {...S}>
      {card(-22, "M80 50 l9 10 l-9 10 l-9 -10 z", "#D81B60")}
      {card(0, "M80 68 C70 60 72 50 80 56 C88 50 90 60 80 68 Z", "#D81B60")}
      {card(22, "M80 50 C88 58 90 64 80 66 C70 64 72 58 80 50 Z M78 66 h4 l2 6 h-8 z", "#142344")}
      <circle cx="24" cy="98" r="7" fill="#F3A126" /><circle cx="136" cy="96" r="5" fill="#142344" />
    </svg>
  );
}

function Lights() {
  const bulbs = [20, 42, 64, 86, 108, 130];
  return (
    <svg viewBox="0 0 160 120" {...S}>
      <path d="M6 30 Q80 96 154 30" fill="none" stroke="#17352D" strokeWidth="1.5" />
      {bulbs.map((x, i) => {
        const by = 30 + 66 * ((x - 6) / 148) * (1 - (x - 6) / 148) * 2;
        return (
          <g key={x}>
            <circle cx={x} cy={by + 10} r="11" fill="#F3A126" opacity=".22" />
            <rect x={x - 2.5} y={by - 2} width="5" height="5" fill="#142344" />
            <path d={`M${x} ${by + 3} C${x + 6} ${by + 8} ${x + 5} ${by + 16} ${x} ${by + 17} C${x - 5} ${by + 16} ${x - 6} ${by + 8} ${x} ${by + 3} Z`} fill={i % 2 ? "#F7B544" : "#F3A126"} />
          </g>
        );
      })}
      <path d="M24 108 q6 -10 12 0 M120 106 q6 -10 12 0" stroke="#142344" strokeWidth="2" fill="none" />
    </svg>
  );
}

export function ActivityArt({ icon, className = "" }) {
  const C = { tray: Tray, mithai: Mithai, cards: Cards, lights: Lights }[icon] || Tray;
  return <div className={className}><C /></div>;
}

export function MoodArt({ mood, className = "" }) {
  const art = {
    mithai: (
      <>
        <rect x="22" y="58" width="76" height="40" rx="6" fill="#D81B60" />
        <rect x="22" y="58" width="76" height="10" fill="#A3134A" />
        {[38, 60, 82].map((x) => <circle key={x} cx={x} cy="52" r="11" fill="#F3A126" />)}
        <circle cx="49" cy="36" r="10" fill="#F7B544" /><circle cx="71" cy="36" r="10" fill="#F3A126" />
        <path d="M30 80 h60" stroke="#FFC83D" strokeWidth="2" strokeDasharray="4 4" />
      </>
    ),
    dance: (
      <>
        <circle cx="46" cy="70" r="20" fill="none" stroke="#142344" strokeWidth="6" />
        <circle cx="62" cy="76" r="20" fill="none" stroke="#F3A126" strokeWidth="6" />
        <path d="M84 30 v34 a8 6 0 1 1 -4 -5 V36 l18 -6 v28 a8 6 0 1 1 -4 -5 V30 z" fill="#142344" />
        {[34, 50, 66].map((x) => <circle key={x} cx={x} cy="100" r="4" fill="#FFC83D" />)}
      </>
    ),
    cards: (
      <>
        <rect x="38" y="44" width="44" height="60" rx="6" fill="#FFF7E8" stroke="#142344" strokeWidth="2" />
        <path d="M60 64 C52 58 53 50 60 55 C67 50 68 58 60 64 Z M60 64 v10" fill="#D81B60" stroke="#D81B60" />
        <path d="M34 34 l10 -16 l16 12 l16 -12 l10 16 z" fill="#F3A126" stroke="#142344" strokeWidth="1.5" />
        <circle cx="44" cy="18" r="3" fill="#142344" /><circle cx="76" cy="18" r="3" fill="#142344" />
      </>
    ),
    conversation: (
      <>
        <path d="M24 60 h34 l-5 38 h-24 z" fill="#C46A3A" />
        <path d="M62 60 h34 l-5 38 h-24 z" fill="#D81B60" />
        <ellipse cx="41" cy="60" rx="17" ry="4" fill="#7A3A1E" /><ellipse cx="79" cy="60" rx="17" ry="4" fill="#6E2E3C" />
        <path d="M36 50 q-6 -8 0 -16 q6 -8 0 -16 M82 50 q-6 -8 0 -16 q6 -8 0 -16" stroke="#142344" strokeWidth="2.5" fill="none" strokeLinecap="round" />
      </>
    ),
  }[mood];
  return (
    <svg viewBox="0 0 120 120" className={className} {...S}>
      {art}
    </svg>
  );
}
